import {
  Amount,
  Box,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableFooterCell,
  TableFooterRow,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
} from '@razorpay/blade/components';
import { CtcBreakdownData } from 'components/PayDetails/types';
import { toIndianCurrencyString } from 'utils/Numbers';
import React from 'react';

interface CtcBreakdownTableProps {
  data: {
    data:
      | CtcBreakdownData['fixed']['data']
      | CtcBreakdownData['variable']['data']
      | CtcBreakdownData['otherCtc']['data'];
    totalMonthlyAmount?: number;
    totalYearlyAmount: number;
  };
  showMonthlyColumn?: boolean;
}

const CtcBreakdownTable = ({ data, showMonthlyColumn = true }: CtcBreakdownTableProps) => {
  const componentData = data.data;
  
  return (
    <Box borderRadius={'large'} overflow={'hidden'}>
      <Table
        data={{
          nodes: componentData,
        }}
        backgroundColor="transparent"
        gridTemplateColumns={showMonthlyColumn ? "2fr 0.5fr 0.5fr" : "1fr 1fr"}>
        {(tableData) => (
          <>
            <TableHeader>
              <TableHeaderRow>
                <TableHeaderCell>
                  <Text weight="semibold">Component</Text>
                </TableHeaderCell>
                {showMonthlyColumn && (
                  <TableHeaderCell textAlign="right">
                    <Text weight="semibold">Per Month</Text>
                  </TableHeaderCell>
                )}
                <TableHeaderCell textAlign="right">
                  <Text weight="semibold">Per Year</Text>
                </TableHeaderCell>
              </TableHeaderRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row) => (
                <TableRow key={row.id} item={row}>
                  <TableCell>
                    <Text>{row.componentName}</Text>
                  </TableCell>
                  {showMonthlyColumn && (
                    <TableCell textAlign="right">
                      {('perMonthAmount' in row ? Number(row.perMonthAmount) : 0) < 0 ? (
                        <Text>{toIndianCurrencyString('perMonthAmount' in row ? Number(row.perMonthAmount) : 0)}</Text>
                      ) : (
                        <Amount value={'perMonthAmount' in row ? Number(row.perMonthAmount) : 0} suffix={'none'}/>
                      )}
                    </TableCell>
                  )}
                  <TableCell textAlign="right">
                    {row.perYearAmount < 0 ? (
                      <Text>{toIndianCurrencyString(row.perYearAmount)}</Text>
                    ) : (
                      <Amount value={row.perYearAmount} suffix={'none'}/>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableFooterRow>
                <TableFooterCell>
                  <Text weight="semibold">Total</Text>
                </TableFooterCell>
                {showMonthlyColumn && (
                  <TableFooterCell textAlign="right">
                    {(data.totalMonthlyAmount ?? 0) < 0 ? (
                      <Text weight="semibold">{toIndianCurrencyString(data.totalMonthlyAmount ?? 0)}</Text>
                    ) : (
                      <Amount value={data.totalMonthlyAmount ?? 0} suffix={'none'}/>
                    )}
                  </TableFooterCell>
                )}
                <TableFooterCell textAlign="right">
                  {data.totalYearlyAmount < 0 ? (
                    <Text weight="semibold">{toIndianCurrencyString(data.totalYearlyAmount)}</Text>
                  ) : (
                    <Amount value={data.totalYearlyAmount} suffix={'none'} />
                  )}
                </TableFooterCell>
              </TableFooterRow>
            </TableFooter>
          </>
        )}
      </Table>
    </Box>
  );
};

export default CtcBreakdownTable;
